export class PeselUtility {
    private static SIXTY_YEARS_OLD: number = 60;
    private static SIXTY_FIVE_YEARS_OLD: number = 65;

    public static PESEL_LENGTH: number = 11;

    public static isAgeOver60FromPesel(pesel: string) {
        const clientAge = PeselUtility.getAgeFromPesel(pesel);
        return (clientAge - PeselUtility.SIXTY_YEARS_OLD) >= 0;
    }

    public static isAgeOver65FromPesel(pesel: string) {
        const clientAge = PeselUtility.getAgeFromPesel(pesel);
        return (clientAge - PeselUtility.SIXTY_FIVE_YEARS_OLD) >= 0;
    }

    public static getAgeFromPesel(pesel: string) {
        let year = parseInt(pesel.substring(0, 2), 10);
        let month = parseInt(pesel.substring(2, 4), 10) - 1;
        const day = parseInt(pesel.substring(4, 6), 10);

        switch (true) {
            case (month >= 80):
                year = year + 1800;
                month = month - 80;
                break;
            case (month >= 60):
                year = year + 2200;
                month = month - 60;
                break;
            case (month >= 40):
                year = year + 2100;
                month = month - 40;
                break;
            case (month >= 20):
                year = year + 2000;
                month = month - 20;
                break;
            default:
                year += 1900;
        }

        const today = new Date();
        let age = today.getFullYear() - year;
        const monthDiff = today.getMonth() - month;

        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < day)) {
            age--;
        }

        return age;
    }
}
